import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UpdateBatchTimelineComponent } from '../update-batch-timeline/update-batch-timeline.component';
import { LoaderService } from 'src/app/utils/loader.service';
import { AdminService } from 'src/app/admin/admin.service';
import { ToastrService } from 'ngx-toastr';

interface DialogData {
  batch: any;
  part: any
}

@Component({
  selector: 'app-update-batch-stage-timelines',
  templateUrl: './update-batch-stage-timelines.component.html',
  styleUrls: ['./update-batch-stage-timelines.component.scss']
})
export class UpdateBatchStageTimelinesComponent implements OnInit {

  stageUpdateForm: FormGroup;
  revised_deadline: any;
  batchDetails: any = {
    id: null,
    dispatch_quantity: '',
    dispatch_date: "",
    timeline_flag: "",
    current_stage: {
      name: "Not available"
    },
    created_at: "",
    updated_at: "",
    is_active: true,
    next_stages: [{
      name: "Not available"
    }],
  };
  batchNumber = 0;

  stages = [
    "Order Accepted",
    "RM Ordered",
    "RM Available",
    "Manufacturing",
    "Painting",
    "Inspection",
    "Inventory",
    "Shipping",
    "Delivered",
    "Paid",
  ];
  partDetails: any;
  allStages: any[];

  constructor(
    public dialogref: MatDialogRef<UpdateBatchStageTimelinesComponent>,
    private loaderService: LoaderService,
    private adminService: AdminService,
    private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private formBuilder: FormBuilder
  ) {
  }

  ngOnInit(): void {
    // TODO: Add reqd validator
    this.stageUpdateForm = this.formBuilder.group({
      rawMaterials: new FormControl(),
      manufacturing: new FormControl(),
      painting: new FormControl(),
      inspection: new FormControl(),
      inventory: new FormControl(),
      shipping: new FormControl(),
      delivery: new FormControl(),
      reason_for_datechange: new FormControl(),
    });
    this.batchDetails.id = this.data?.batch?._id || 1;
    this.partDetails = this.data?.part
    this.fetchAllStages();
    this.fetchBatch();
  }

  getBatchNumber() {
    const index = this.partDetails.dispatch_batch.findIndex(
      (item) => item._id === this.batchDetails?._id
    )
    this.batchNumber = index + 1;
  }

  close() {
    this.dialogref.close();
  }

  fetchAllStages() {
    this.adminService.fetchAllBatchStages().subscribe((res) => {
      this.allStages = res['body'];
      this.allStages = this.allStages.filter(stage => ![1, 10].includes(stage?.id))
      console.log(this.allStages);
    })
  }

  //TODO: Remove disabled attr from template and disable form control dynamically
  hasStagePassed(batchname: string) {
    const batchIndex = this.stages.indexOf(batchname) + 1;
    if ([2, 3].includes(this.batchDetails?.current_stage.id) && batchIndex === 3) {
      return true;
    }
    if (batchIndex <= this.batchDetails?.current_stage.id) {
      return true;
    }
    return false;
  }

  fetchBatch() {
    this.adminService.fetchVendorOrderItemBatch(this.batchDetails.id).subscribe(
      (res: any) => {
        console.log(res?.body)
        this.batchDetails = res?.body;
        const stagePlans = this.batchDetails?.stage_plans;
        this.stageUpdateForm.patchValue({
          rawMaterials: stagePlans.find(p => p.stage_value === "rm_available")?.planned_date,
          manufacturing: stagePlans.find(p => p.stage_value === "manufacturing")?.planned_date,
          painting: stagePlans.find(p => p.stage_value === "painting")?.planned_date,
          inspection: stagePlans.find(p => p.stage_value === "inspection")?.planned_date,
          inventory: stagePlans.find(p => p.stage_value === "inventory")?.planned_date,
          shipping: stagePlans.find(p => p.stage_value === "shipping")?.planned_date,
          delivery: stagePlans.find(p => p.stage_value === "delivered")?.planned_date,
        })
        this.revised_deadline = new Date(this.batchDetails?.revised_deadline)
        this.loaderService.display(false);
        this.getBatchNumber();
      },
      (err) => {
        this.loaderService.display(false);
        for (let i in err.error.errors) {
          this.toastr.error(err.error.errors[i], "Error");
        }
      }
    );
  }

  submitForm() {
    let formData = {};
    const stagePlans = this.allStages.map((stage) => (
      {
        "stage_id": stage?._id || stage?.id,
        "planned_date": this.getPlannedDate(stage?._id || stage?.id)
      }
    ))
    formData['stage_plans'] = stagePlans
    formData['data_change_reason'] = this.stageUpdateForm.get('reason_for_datechange').value;
    this.adminService.updateBatchTimeline(this.batchDetails?.vendor_order_item_id, this.batchDetails?.id, formData).subscribe((res)=> {
      this.toastr.success("Batch timeline updated successfully")
      this.dialogref.close(true);
    }, (err)=> {
      this.toastr.error("Batch timeline not updated successfully")
      this.dialogref.close(false);
    })
  }

  private getPlannedDate(stageId: number) {
    switch (stageId) {
      case 2:
        return this.stageUpdateForm.get('rawMaterials').value;
      case 3:
        return this.stageUpdateForm.get('rawMaterials').value;
      case 4:
        return this.stageUpdateForm.get('manufacturing').value;
      case 5:
        return this.stageUpdateForm.get('painting').value;
      case 6:
        return this.stageUpdateForm.get('inspection').value;
      case 7:
        return this.stageUpdateForm.get('inventory').value;
      case 8:
        return this.stageUpdateForm.get('shipping').value;
      case 9:
        return this.stageUpdateForm.get('delivery').value;
      default:
        return this.batchDetails.dispatch_date; //:Should never come to this
    }
  }

  patchFormValues(formControlName:string, value:any){
    this.stageUpdateForm.get(formControlName).patchValue(value);
  }

}
